import React, { Component } from "react";
// import moment from "moment";
import less from "./seatView.module.scss";
import cx from "classnames";

const styles = {
  busDeck: (r, c) => {
    return {
      display: "grid",
      gridTemplateColumns: `repeat(${c}, minmax(2%, 2rem) )`,
      gridTemplateRows: `repeat(${r}, minmax(2%, 2rem) )`,
      gap: "7px",
      justifyContent: "center"
    };
  }
};

const mobileStyles = {
  background: "#ffffff",
  borderRadius: "10px",
  width: "fit-content",
  padding: "17px 34px",
  margin: "12px 0"
};

class SeatView extends Component {
  state = {
    isMobile: true,
    selectedBerth: this.props.isUpperDeckOnly ? 2 : 1
  };

  onChange = (key, value) => {
    this.setState({ [key]: value });
  };

  seatRow = seat => {
    const { seatSelected } = this.props;
    const { type, id, dimension, seatLabel, orientation, positionType } = seat;
    let className, classType;
    if (type === "FIRE_EXIT") {
      if (positionType === "ROOF") {
        className = less.fireExitRoof;
      } else {
        switch (orientation) {
          case "REAR": {
            className = less.fireExitRear;
            break;
          }
          case "LEFT": {
            className = less.fireExitLeft;
            break;
          }
          case "RIGHT": {
            className = less.fireExitRight;
            break;
          }
        }
      }

      return <div key={seat.id} className={className} />;
    }

    if (type === "HAMMER") {
      return <div key={id} className={cx(less.hammerIcon)} />;
    }

    if (type === "FIRE_EXTINGUISHER") {
      return <div key={id} className={cx(less.fireExtinguisherIcon)} />;
    }

    if (type === "FIRST_AID") {
      return <div key={id} className={cx(less.firstAidIcon)} />;
    }
    if (type === "AMENITY_GROUP") {
      const items = seat.items || [];
      const side = seat?.columnIndex > 2 ? "right" : "left";
      return (
        <div className={cx(less.amenityCluster, less[side])}>
          {items.slice(0, 3).map((item, index) => {
            let iconClass = "";

            switch (item.type) {
              case "HAMMER":
                iconClass = less.hammerIcon;
                break;
              case "FIRST_AID":
                iconClass = less.firstAidIcon;
                break;
              case "FIRE_EXTINGUISHER":
                iconClass = less.fireExtinguisherIcon;
                break;
              default:
                return null;
            }

            return (
              <div
                key={item.id}
                className={cx(
                  less.amenityBubble,
                  iconClass,
                  less[`pos${index}`]
                )}
              />
            );
          })}
        </div>
      );
    }
    const myToolTipClass = less.tooltipWrapper;
    if (seat === -1) {
      return;
    }

    switch (dimension) {
      case "1": {
        className = less.seat1x1;
        break;
      }
      case "2L": {
        className = less.seat2x1;
        break;
      }
      case "2W": {
        className = less.seat1x2;
        break;
      }
      case "2LW": {
        className = less.seat2x2;
        break;
      }
      default: {
        break;
      }
    }

    if (seatSelected[id]) {
      classType = less.selected;
    } else {
      classType = less.disabled;
    }
    if (seat) {
      return (
        <div
          key={seatLabel}
          className={cx(
            className,
            myToolTipClass,
            classType,
            "text-center vertical-center"
          )}
        >
          {seatSelected[id] ? (
            seatLabel.length > 1 ? (
              <span className={cx("small", less.seatLabel, less.reduceFont)}>
                {seatLabel}
              </span>
            ) : (
              <span className={cx("small", less.seatLabel)}>{seatLabel}</span>
            )
          ) : (
            <span className={cx("small", less.seatLabel)}>{seatLabel}</span>
          )}
        </div>
      );
    } else {
      return <div key={seatLabel} />;
    }
  };

  createDeck = (deck, addDriverSeat = false) => {
    const { driverCabinSafetyEquipments } = this.props;
    const r = deck.length;
    const c = deck[0].length;
    const driverRow = [];

    for (let i = 0; i < c; ++i) {
      if (i === 0 && addDriverSeat) {
        driverRow.push(
          <div
            key={`entry-icon-${i}`}
            className={less.entryIcon}
            style={{ gridColumn: "span 2" }}
          ></div>
        );
      } else if (i === 1 && addDriverSeat) {
        continue;
      } else if (i + 2 === c && addDriverSeat) {
        driverRow.push(
          <div key={`d-seat-${i}`} className={less.driverSeat}></div>
        );
      } else if (i + 1 === c && addDriverSeat) {
        driverRow.push(
          <div
            className={cx(less.amenityCluster, less["left"])}
            key={`d-amenity-${i}`}
          >
            {driverCabinSafetyEquipments &&
              driverCabinSafetyEquipments.slice(0, 3).map((item, index) => {
                let iconClass = "";

                switch (item) {
                  case "EMERGENCY_HAMMER":
                    iconClass = less.hammerIcon;
                    break;
                  case "FIRST_AID_KIT":
                    iconClass = less.firstAidIcon;
                    break;
                  case "FIRE_EXTINGUISHER":
                    iconClass = less.fireExtinguisherIcon;
                    break;
                  default:
                    return null;
                }

                return (
                  <div
                    key={`${item}-${index}`}
                    className={cx(
                      less.amenityBubble,
                      iconClass,
                      less[`pos${index}`]
                    )}
                  />
                );
              })}
          </div>
        );
      } else {
        driverRow.push(<div key={`d-seat-${i}`}></div>);
      }
    }

    return (
      <div
        className={less.rootContainer}
        style={{
          borderRadius: this.props.noOfDeck > 1 ? "0 0 12px 12px" : "12px"
        }}
      >
        <div className={less.seatIllustrationContainer}>
          <div
            className={less.seatIllustration}
            style={{
              display: this.state.isMobile ? "flex" : "",
              justifyContent: this.state.isMobile ? "center" : ""
            }}
          >
            <div
              style={{
                ...styles.busDeck(r, c),
                ...(this.state.isMobile ? mobileStyles : {})
              }}
              className={less.seatGrid}
            >
              {driverRow.map(d => d)}
              {deck.map(row => row.map(this.seatRow))}
            </div>
          </div>
        </div>
      </div>
    );
  };
  render() {
    const { lowerDeck = {}, upperDeck = {} } = this.props.seat.seatMap || {};
    const { noOfDeck } = this.props;
    const { selectedBerth } = this.state;
    return (
      <>
        {noOfDeck > 1 ? (
          <div className={less.lowerUpperContainer}>
            <div className={less.toggleContainerUpperLower}>
              <div
                className={`${less.slider} ${
                  selectedBerth === 1 ? less.left : less.right
                }`}
              ></div>
              <button
                className={`${less.buttonSytle} ${
                  selectedBerth === 1 ? less.active : ""
                }`}
                onClick={() => this.onChange("selectedBerth", 1)}
              >
                Lower
              </button>
              <button
                className={`${less.buttonSytle} ${
                  selectedBerth === 2 ? less.active : ""
                }`}
                onClick={() => this.onChange("selectedBerth", 2)}
              >
                Upper
              </button>
            </div>
          </div>
        ) : null}
        {lowerDeck.available && selectedBerth === 1
          ? this.createDeck(lowerDeck.seatGraph, true)
          : null}
        {upperDeck.available && selectedBerth === 2
          ? this.createDeck(upperDeck.seatGraph)
          : null}
      </>
    );
  }
}

export default SeatView;
